<div class="d-flex w-100 flex-column">
    <div class="dataset-breadcrumb d-flex flex-grow-1 align-items-center" data-uit="dataset-breadcrumb">
        <div class="d-flex" *ngIf="prependToBreadcrumb != null">
            <a (click)="clickOnPrependedBreadcrumbElement.emit()">
                {{ prependToBreadcrumb }}
            </a>
            <ca-icon name="arrow-right" size="s" class="ca-color-on-background-on-surface mx-1" *ngIf="isLeavingDatasetAllowed"></ca-icon>
        </div>
        <a (click)="navigateBackToOverview()" *ngIf="isLeavingDatasetAllowed" data-uit="breadcrumb-my-datasets-root">
            {{ 'MACHINE_LEARNING.MY_DATASETS' | translate }}
        </a>
        <ca-icon name="arrow-right" size="s" class="ca-color-on-background-on-surface mx-1" *ngIf="isLeavingDatasetAllowed"></ca-icon>
        <div *ngIf="!isLeavingTheFolderAllowed" class="h-100 d-flex flex-column justify-content-center">
            <span class="breadcrumb-caption" data-uit="dataset-explorer-breadcrumb-caption-current-dataset-name">{{ currentDataset.name }}</span>
        </div>
        <a *ngIf="isLeavingTheFolderAllowed" (click)="openRoot()">
            <span data-uit="dataset-explorer-breadcrumb-caption-current-dataset-name">{{ currentDataset.name }}</span>
        </a>
        <ca-icon name="arrow-right" size="s" class="ca-color-on-background-on-surface mx-1" *ngIf="history?.length > 0"></ca-icon>
        <div *ngFor="let folder of history">
            <span class="breadcrumb-caption" data-uit="dataset-explorer-breadcrumb-caption-folder-name">{{ folder.name }}</span>
        </div>
    </div>
</div>
<div class="d-flex justify-content-lg-end justify-content-start">
    <div *ngIf="isButtonBarShown" class="d-flex flex-wrap flex-column flex-md-row mt-2 mb-4 btn-section-sm-responsive">
        <button
            type="button"
            *ngIf="!isCurrentFolderAnnotationsFolder()"
            class="btn btn-secondary me-0 me-lg-3 mt-2 mt-sm-2 mt-lg-2 btn-sm-viewport-width"
            caAutoFocus
            data-uit="add-files-to-dataset-btn"
            (click)="addImagesToDataset()"
        >
            <ca-icon name="plus" size="s"></ca-icon> {{ 'MACHINE_LEARNING.ANNOTATE.ADD_IMAGES_TO_DATASET' | translate }}
        </button>
        <div
            [ngbTooltip]="trainButtonTooltip"
            container="body"
            [disableTooltip]="hasAnnotations && invalidFiles.length === 0 && pendingFilesToValidate.length === 0"
            placement="top"
        >
            <ng-template #limitReachedContent let-msg="msg">{{ msg }}</ng-template>
            <button
                type="button"
                class="btn btn-secondary me-0 me-md-2 me-lg-3 mt-2 mt-sm-2 mt-lg-2 btn-sm-viewport-width"
                triggers="manual"
                placement="bottom"
                caLimitValidator
                [isDisabled]="!hasAnnotations || invalidFiles.length > 0 || pendingFilesToValidate.length > 0"
                #t1="ngbTooltip"
                [ngbTooltip]="limitReachedContent"
                [workflowType]="workflowType.SEGMENTATION_TRAINING"
                [tooltip]="t1"
                (next)="onUseForTrainingButtonClick()"
                data-uit="dataset-explorer-use-for-training-btn"
            >
                <ca-icon name="training" size="s"></ca-icon> {{ 'MACHINE_LEARNING.ANNOTATE.USE_FOR_TRAINING' | translate }}
            </button>
        </div>
        <ng-template #trainButtonTooltip>
            <div>
                <span *ngIf="(hasAnnotations && !hasImages) || (!hasAnnotations && !hasImages)">
                    {{ 'MACHINE_LEARNING.ANNOTATE.ANNOTATE_TOOLTIP_ADD_IMAGES' | translate }}
                </span>
                <span *ngIf="invalidFiles.length > 0 || pendingFilesToValidate.length > 0">
                    {{ 'MACHINE_LEARNING.ANNOTATE.ANNOTATE_TOOLTIP_CONTAINS_INVALID_FILES' | translate }}
                </span>
                <span *ngIf="!hasAnnotations && hasImages && invalidFiles.length === 0 && pendingFilesToValidate.length === 0">{{
                    'MACHINE_LEARNING.ANNOTATE.PLEASE_ADD_ANNOTATIONS_FIRST' | translate
                }}</span>
            </div>
        </ng-template>
        <div
            [ngbTooltip]="annotateButtonTooltip"
            container="body"
            placement="bottom"
            [disableTooltip]="
                hasImages &&
                !hasOver1kImages &&
                invalidFiles.length === 0 &&
                pendingFilesToValidate.length === 0 &&
                isCziConversionInProgress &&
                isValidationInProgress
            "
        >
            <button
                type="button"
                [disabled]="
                    !hasImages ||
                    hasOver1kImages ||
                    invalidFiles.length > 0 ||
                    pendingFilesToValidate.length > 0 ||
                    isCziConversionInProgress ||
                    isValidationInProgress
                "
                class="btn btn-primary mt-2 mt-sm-2 mt-lg-2 btn-sm-viewport-width"
                caAutoFocus
                (click)="annotate()"
                data-uit="dataset-explorer-annotate-btn"
            >
                <ca-icon name="pen" size="s"></ca-icon> {{ 'MACHINE_LEARNING.ANNOTATE.ANNOTATE' | translate }}
            </button>
        </div>
        <ng-template #annotateButtonTooltip>
            <div>
                <span *ngIf="invalidFiles.length > 0 || pendingFilesToValidate.length > 0">
                    {{ 'MACHINE_LEARNING.ANNOTATE.ANNOTATE_TOOLTIP_CONTAINS_INVALID_FILES' | translate }}
                </span>
                <span *ngIf="hasOver1kImages">{{ 'MACHINE_LEARNING.ANNOTATE.SUPPORT_UP_TO_1k_IMAGES' | translate }}</span>
                <span *ngIf="!hasImages">{{ 'MACHINE_LEARNING.ANNOTATE.ANNOTATE_TOOLTIP_ADD_IMAGES' | translate }}</span>
            </div>
        </ng-template>
    </div>
</div>
<div class="dataset-explorer-body overflow-hidden">
    <ng-container *ngIf="filesOrFolders[0] && isFolder(filesOrFolders[0])">
        <div class="dataset-explorer-items">
            <ng-container *ngFor="let dirOrFile of filteredFilesOrFolders">
                <ca-dataset-item
                    (onClick)="openFolder(dirOrFile.folderType)"
                    [isFolder]="true"
                    [filesTableMode]="isUploadModal ? FILE_EXPLORER_MODE.SELECTION : FILE_EXPLORER_MODE.MODIFICATION"
                    [numberOfFiles]="getNumberOfFilesOfFolder(dirOrFile)"
                    [numberOfInvalidFiles]="numberOfInvalidFiles(dirOrFile)"
                    [name]="dirOrFile.name"
                ></ca-dataset-item>
            </ng-container>
        </div>
    </ng-container>
    <ng-container>
        <div [ngClass]="!isLoadingDatasets && filesOrFolders.length === 0 ? 'no-files-available-wrapper' : ''">
            <span *ngIf="!isLoadingDatasets && filesOrFolders.length === 0" data-uit="dataset-explorer-no-files-available">{{
                'MACHINE_LEARNING.ANNOTATE.NO_FILES_AVAILABLE' | translate
            }}</span>
        </div>

        <ca-list-shell
            *ngIf="filesOrFolders.length > 0 && !isFolder(filesOrFolders[0])"
            class="dataset-files-list-shell h-100"
            (onTriggerSearchAndSort)="onTriggerSearch($event)"
            [emptyListMessage]="
                !isCurrentFolderFilesFolder() && !isCurrentFolderAnnotationsFolder() ? ('MACHINE_LEARNING.NO_DATASETS_AVAILABLE' | translate) : ''
            "
            [totalItemsCount]="filteredFilesOrFolders.length"
            [showCategoryButton]="false"
            [sortOptions]="sortOptions"
            [isUploadModal]="isUploadModal"
            [updateParameterQuery]="updateParameterQuery"
        >
            <ng-container *ngIf="!isUploadModal && currentFolder?.folderType !== datasetFileTypeOption.ANNOTATIONS">
                <div class="d-flex align-items-center" *ngIf="!isCziConversionInProgress">
                    <ca-invalid-files-info
                        *ngIf="invalidFiles?.length > 0 || unknownFiles.length > 0"
                        [datasetId]="currentDataset?.datasetId"
                        [invalidFiles]="invalidFiles"
                        [unknownFiles]="unknownFiles"
                        (removeFiles)="delete($event)"
                    ></ca-invalid-files-info>
                    <button
                        *ngIf="invalidFiles?.length > 0 || unknownFiles.length > 0"
                        data-uit="dataset-explorer-revalidate-btn"
                        type="button"
                        class="btn ca-btn-icon btn-m"
                        (click)="reValidate()"
                        [ngbTooltip]="'FILE_VALIDATION.REVALIDATE' | translate"
                    >
                        <ca-icon name="circle-arrow" [removeSVGAttributes]="['stroke']" size="s"></ca-icon>
                    </button>
                </div>
                <ca-czi-conversion-info
                    [isDatasetPage]="true"
                    [isInvalidFilesNotificationVisible]="invalidFiles.length > 0"
                    [messagingCallbackAction]="retryMessagingAction"
                    [files]="datasetFiles?.files"
                    [isConversionInProgress]="isCziConversionInProgress"
                ></ca-czi-conversion-info>
            </ng-container>
            <ca-files-table
                *ngIf="filesOrFolders.length > 0"
                [mode]="filesTableMode"
                [isLoading]="isLoadingDatasets"
                [isFilesStatusShown]="isFilesStatusShown && currentFolder?.folderType !== datasetFileTypeOption.ANNOTATIONS"
                [items]="pagedFilesOrFolders"
                [totalRowCount]="filteredFilesOrFolders.length"
                [columns]="fileColumns"
                [actions]="fileActions"
                [datasetFileType]="currentFolder?.folderType"
                [isDownloadAnnotationsTrackingEventEnabled]="isDownloadAnnotationsTrackingEventEnabled"
                [datasetId]="currentDataset?.datasetId"
                [isAddAllFilesClickButtonShown]="showSelectAllFilesButton && filteredFilesOrFolders.length > 0"
                [totalNumberOfFiles]="filteredFilesOrFolders.length"
                [myFilesClass]="true"
                [showFileStatus]="showFileStatus"
                [truncateFileNameAtWidthOf]="200"
                (onClickOnFile)="clickFile($event)"
                (deleteItems)="delete($event)"
                (addAllFilesClick)="
                    filteredFilesOrFolders.length > 0 && !isFolder(filteredFilesOrFolders[0])
                        ? selectMultipleFiles.emit(getTypedAsFileModelArray(filteredFilesOrFolders))
                        : null
                "
                class="files-table"
            ></ca-files-table>
        </ca-list-shell>
    </ng-container>
</div>
